import { useEffect, useState, useMemo } from 'react'
import AdminLayout from '../../layouts/AdminLayout'
import {
    Box, Button, Flex, HStack,
    Table, Thead, Tbody, Tr, Th, Td, TableContainer,
    FormControl, FormLabel, Grid, Input, Select, IconButton,
} from "@chakra-ui/react";
import { FaEdit, FaFileCsv, FaFilePdf } from "react-icons/fa";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import adminService from '../../services/adminService';

import ReactPaginate from "react-paginate";
import { exportToPDF } from '../../utils/pdfExporter';
import { exportToCSV } from '../../utils/csvExporter';

const validationSchema = Yup.object().shape({
    Msg: Yup.string().required("Message is required"),
    MFrom: Yup.string().required("Message From is required"),
    RMsgId: Yup.string().required("RMsgId is required"),
    Stat: Yup.string().required("Stat is required"),
    TStat: Yup.string().required("Input is required"),
});

const ITEMS_PER_PAGE = 10;

const ChatMsg = () => {

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        setValue
    } = useForm({
        resolver: yupResolver(validationSchema),
    });

    const [data, setData] = useState([])
    const [MsgId, setMsgId] = useState(0)

    const [search, setSearch] = useState("");
    const [page, setPage] = useState(0);
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState("asc");

    useEffect(() => {
        chatList();
    }, [])

    const chatList = async () => {
        try {
            const res = await adminService.getChatMsg()

            if (res.statusCode === 200) {
                setData(res.data)
            }
        } catch (error) {
            alert(error.response?.data?.message || "Something went wrong.");
        }
    }

    const handleConfig = async (data) => {
        data.MsgId = MsgId;
        try {
            const res = await adminService.saveChatMsg(data)

            setMsgId(0)
            if (res.statusCode === 200) {
                alert(res.message);
                reset();
                chatList();
            }
        } catch (error) {
            alert(error.response?.data?.message || "Something went wrong.");
        }
    }

    const handleEdit = (row) => {
        setValue("Msg", row.Msg);
        setValue("MFrom", row.MFrom);
        setValue("RMsgId", row.RMsgId);
        setValue("TStat", row.TStat);
        setValue("Stat", row.Stat);
        setMsgId(row.MsgId)
    };

    const filteredData = useMemo(() => {
        let result = [...data];
        if (search) {
            const lowerSearch = search.toLowerCase();
            result = result.filter((item) =>
            (`${item.Msg}`.toLowerCase().includes(lowerSearch) ||
                item.MFrom.toLowerCase().includes(search.toLowerCase()) ||
                String(item.RMsgId).includes(search.toLowerCase()) ||
                String(item.MsgId).includes(search.toLowerCase()) ||
                String(item.Stat).includes(lowerSearch))
            );
        }
        if (sortField) {
            result.sort((a, b) => {
                let aVal = a[sortField] ?? '';
                let bVal = b[sortField] ?? '';

                return sortOrder === "asc" ? aVal > bVal ? 1 : -1 : aVal < bVal ? 1 : -1;
            });
        }
        return result;
    }, [data, search, sortField, sortOrder]);

    const pageCount = Math.ceil(filteredData.length / ITEMS_PER_PAGE);

    const currentData = useMemo(() => {
        const start = page * ITEMS_PER_PAGE;
        return filteredData.slice(start, start + ITEMS_PER_PAGE);
    }, [filteredData, page]);

    const handleSort = (field) => {
        if (sortField === field) {
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortField(field);
            setSortOrder("asc");
        }
    };

    const handlePageChange = ({ selected }) => {
        setPage(selected);
    };

    const exportCSV = () => {
        // data, filename
        exportToCSV(filteredData, "chatmsg.csv")
    };

    const exportPDF = () => {
        const columns = [
            { label: "MsgId", accessor: "MsgId" },
            { label: "Msg", accessor: "Msg" },
            { label: "MFrom", accessor: "MFrom" },
            { label: "RMsgId", accessor: "RMsgId" },
            { label: "Input", accessor: "TStat" },
            { label: "Status", accessor: "Stat" },
        ];

        exportToPDF({
            data: filteredData,      // your actual data array
            columns,
            fileName: "chatmsg.pdf"
        });
    };

    return (
        <AdminLayout>
            <Box maxW="1000px" mx="auto" px={4}>
                {/* Form Section */}
                <Box
                    bg="white"
                    p={6}
                    rounded="xl"
                    boxShadow="md"
                    mb={3}
                    border="1px solid"
                    borderColor="gray.200"
                >
                    <form onSubmit={handleSubmit(handleConfig)}>
                        <Grid
                            templateColumns={{ base: "1fr", md: "repeat(4, 1fr)" }}
                            gap={6}
                        >
                            <FormControl>
                                <FormLabel fontSize="sm">Message</FormLabel>
                                <Input type="text" {...register("Msg")} size="sm" />
                                <Box color="red.500" fontSize="xs">{errors.Msg?.message}</Box>
                            </FormControl>

                            <FormControl>
                                <FormLabel fontSize="sm">MFrom</FormLabel>
                                <Select {...register("MFrom")} size="sm">
                                    <option value=''>Select</option>
                                    <option value='D'>Driver</option>
                                    <option value='P'>Passenger</option>
                                    <option value='B'>Both</option>
                                </Select>
                                <Box color="red.500" fontSize="xs">{errors.MFrom?.message}</Box>
                            </FormControl>

                            <FormControl>
                                <FormLabel fontSize="sm">R Message</FormLabel>
                                <Input type="number" {...register("RMsgId")} size="sm" />
                                <Box color="red.500" fontSize="xs">{errors.RMsgId?.message}</Box>
                            </FormControl>

                            <FormControl>
                                <FormLabel fontSize="sm">Input Box</FormLabel>
                                <Select {...register("TStat")} size="sm">
                                    <option value={0}>No Input</option>
                                    <option value={1}>Input</option>
                                </Select>
                                <Box color="red.500" fontSize="xs">{errors.TStat?.message}</Box>
                            </FormControl>

                            <FormControl>
                                <FormLabel fontSize="sm">Stat</FormLabel>
                                <Select {...register("Stat")} size="sm">
                                    <option value={0}>Enable</option>
                                    <option value={1}>Disable</option>
                                </Select>
                                <Box color="red.500" fontSize="xs">{errors.Stat?.message}</Box>
                            </FormControl>

                        </Grid>

                        <Button type="submit" colorScheme="blue" mt={6} size="sm">
                            Submit
                        </Button>
                    </form>
                </Box>

                {/* Table + Controls Section */}
                <Box
                    bg="white"
                    p={6}
                    rounded="xl"
                    boxShadow="md"
                    border="1px solid"
                    borderColor="gray.200"
                >
                    <Flex justify="space-between" mb={4} flexWrap="wrap" gap={4}>
                        <Input
                            placeholder="Search by name..."
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                                setPage(0);
                            }}
                            maxW="300px"
                            size="sm"
                        />
                        <HStack>
                            <Button
                                size="sm"
                                colorScheme="blue"
                                leftIcon={<FaFileCsv />}
                                onClick={exportCSV}
                            >
                                CSV
                            </Button>
                            <Button
                                size="sm"
                                colorScheme="red"
                                leftIcon={<FaFilePdf />}
                                onClick={exportPDF}
                            >
                                PDF
                            </Button>
                        </HStack>
                    </Flex>
                    <TableContainer overflowX="auto">
                        <Table size="sm" variant="simple">
                            <Thead bg="gray.100">
                                <Tr>
                                    <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("MsgId")}>#</Th>
                                    <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("Msg")}>MSG</Th>
                                    <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("MFrom")}>MFrom</Th>
                                    <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("RMsgId")}>RMsgId</Th>
                                    <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("TStat")}>Input</Th>
                                    <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("Stat")}>Stat</Th>
                                    <Th px={2} py={1}>Action</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {currentData.map((row, index) => (
                                    <Tr key={row.MsgId}>
                                        <Td px={2} py={1}>{row.MsgId}</Td>
                                        <Td px={2} py={1}>{row.Msg}</Td>
                                        <Td px={2} py={1}>{row.MFrom}</Td>
                                        <Td px={2} py={1}>{row.RMsgId}</Td>
                                        <Td px={2} py={1}>{row.TStat === 1 ? "Yes" : "No"}</Td>
                                        <Td px={2} py={1}>{row.Stat === 0 ? "Enable" : "Disable"}</Td>
                                        <Td>
                                            <IconButton
                                                icon={<FaEdit />}
                                                aria-label="Edit"
                                                borderRadius="full"
                                                onClick={() => handleEdit(row)}
                                            />
                                        </Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </TableContainer>
                </Box>

                <Box mt={6}>
                    <ReactPaginate
                        previousLabel="Previous"
                        nextLabel="Next"
                        pageCount={pageCount}
                        onPageChange={handlePageChange}
                        containerClassName="pagination"
                        activeClassName="active"
                        pageClassName="page-item"
                        previousClassName="page-item"
                        nextClassName="page-item"
                        breakClassName="page-item"
                        pageLinkClassName="page-link"
                        previousLinkClassName="page-link"
                        nextLinkClassName="page-link"
                        breakLinkClassName="page-link"
                    />
                </Box>

                <style>{`
                                              .pagination {
                                                display: flex;
                                                justify-content: center;
                                                list-style: none;
                                                padding: 0;
                                                margin-top: 1rem;
                                              }
                                              .page-item {
                                                margin: 0 5px;
                                              }
                                              .page-link {
                                                padding: 8px 12px;
                                                border-radius: 6px;
                                                background-color: #e2e8f0;
                                                cursor: pointer;
                                              }
                                              .page-link:hover {
                                                background-color: #cbd5e0;
                                              }
                                              .active .page-link {
                                                background-color: #3182ce;
                                                color: white;
                                              }
                                            `}</style>

            </Box>
        </AdminLayout>
    )
}

export default ChatMsg
